import { useQuery } from "@tanstack/react-query";
import { getSystemSetting } from "../api/admin";

const useGetSystemSetting = () => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["SystemSetting"],
    queryFn: getSystemSetting,
    retry: false,
    enabled: true,
  });

  return { data, isLoading, isSuccess };
};

export default useGetSystemSetting;
